// same height
function autoHeight(str,flag=true,val=false){
    let el_height_list=[];
       $(str).each(function(){
        let el_height=$(this).outerHeight(flag);
         let el_height_1=$(this).height();
         el_height_list.push(el_height);
         // console.log('eee',str,el_height)
      })
        let  max = Math.max.apply(null, el_height_list);
 if(val){
    return max;
  }else{
    $(str).css('height',`${max}px`);
  }
}

// copy text
function copyText(str){
      $(str).click(function (e) {
      let that = $(this);
      var text = that.prev().text();
      var input = document.createElement('input');
      input.value = (text + '').trim();
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      that.addClass('success');
      setTimeout(() => {
        that.removeClass('success');
      }, 1000);
    });
}
// 节流，scroll
function reduceExpend(fn, delay=500) {
  let startTime = 0;
  return function () {
    let nowTime = new Date().getTime();
    let waitTime = delay - (nowTime - startTime);
    if (waitTime <= 0) {
      startTime = nowTime;
      fn();
    }
  };
}

// is Inviewport
function isViewPort(el){
  var elementTop = $(el).offset().top;
var elementBottom = elementTop + $(el).outerHeight() / 2;
var viewportTop = $(window).scrollTop();
var viewportHalf = viewportTop + $(window).height() / 2;
return elementBottom > viewportTop && elementTop < viewportHalf;


}
// resize
function resizeCustomFn(fn) {
    fn();
    $(window).resize(function () {
      fn();
  });
}

// scrolltrigger
let window_height = window.innerHeight * 2
function triggerResizeOnEnterViewport(selector,callback) {
  const target = document.querySelector(selector);
  
  if (target) {
    const resizeObserver = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
      //window.dispatchEvent(new Event('resize'));
        if(callback){
           callback()
        }else{
          ScrollTrigger.refresh();
        }
        resizeObserver.disconnect();
      }
    }, { threshold: 0, rootMargin: `-${window_height}px 0px 0px 0px`, });

    resizeObserver.observe(target);
  }
}

function buyNowProduct(id){
   $('#upCart').hide();
        var itemsToAdd = [
          {
            id: id,
            quantity: 1,
          },
        ];
  
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: {
            items: itemsToAdd,
          },
          dataType: 'json',
          success: function () {
            window.location.href = '/checkout';
          },
          error: function () {
            $('#upCart').show();
            console.log('加购失败，请重试。');
          },
        });
}